import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FontKey } from '../../utils/fonts';

export interface ThemeState {
  fontKey: FontKey; // global font selection
  primaryColor: string; // primary brand color from JSON
}

const initialState: ThemeState = {
  fontKey: 'poppins', // Default font
  primaryColor: '#3498DB', // Default primary color
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<Partial<ThemeState>>) {
      return { ...state, ...action.payload };
    },
    setPrimaryColor(state, action: PayloadAction<string>) {
      state.primaryColor = action.payload;
    },
    setFontKey(state, action: PayloadAction<FontKey>) {
      state.fontKey = action.payload;
    },
  },
});

export const { setTheme, setPrimaryColor, setFontKey } = themeSlice.actions;
export default themeSlice.reducer;
